import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import KaiFloatingButton from "@/components/KaiFloatingButton";
import { Toaster } from "sonner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0a0a0f] text-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <KaiFloatingButton />
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}
